import { z } from "zod";
export const jwtPayloadSchema = z.object({
    user_id: z.string(),
    email: z.string(),
    role: z.union([z.literal("owner"), z.literal("tenant")]),
});
